import { useCallbackEffect, useLoggingCallback } from '@databases/react';
import {
  type OptionalCreatePageReferenceOrContentId,
  type ResolvedBlogpostReference,
  type ResolvedPageReference
} from '@databases/types/confluence';
import { contentToReference, isContent } from '@databases/utils/confluence/utils';
import { loadContentById } from '@databases/utils/redux/content/actions';
import { selectContentByIdOptional } from '@databases/utils/redux/content/selectors';

import { defaultStoreUtils } from './redux.ts';

export const useResolvedReference = (
  contentRef: OptionalCreatePageReferenceOrContentId | undefined
): ResolvedPageReference | ResolvedBlogpostReference | undefined => {
  const dispatch = defaultStoreUtils.useDispatch();
  useCallbackEffect(
    useLoggingCallback(async () => {
      if (!contentRef) {
        return;
      }
      if ('contentId' in contentRef && contentRef.contentId) {
        await dispatch(loadContentById(contentRef.contentId));
      }
    }, [dispatch, contentRef])
  );

  const resolvedContentRef:
    | ResolvedPageReference
    | ResolvedBlogpostReference
    | undefined = defaultStoreUtils.useEqualSelector((state) => {
    if (!contentRef) {
      return undefined;
    }
    if ('contentId' in contentRef) {
      const resolvedRef = selectContentByIdOptional(state, {
        contentId: contentRef.contentId
      });
      if (resolvedRef) {
        if (
          isContent(resolvedRef) &&
          (resolvedRef.type === 'page' || resolvedRef.type === 'blogpost')
        ) {
          return contentToReference(resolvedRef);
        }
      }
    }
  });

  return resolvedContentRef;
};
